import {useSelector} from "react-redux";
import {RootState} from "@/store";
import BookingInsightPieLayoutResult
  , {
  PieChartData,
  PieLayoutSummaryData, PieLayoutTableData
} from "@/pages/Report/BookingInsightPieLayoutResult";
import {currencyFormat} from "@/utils";
import {pieColors} from "@/pages/Report/constant";

const BookingCourtResult
  = () => {
  const bookingVenue = useSelector((state: RootState) => state.bookingInsight.state.bookingVenue)
  const details = bookingVenue?.details ?? []
  const summaryData = {
    totalHours: bookingVenue?.total_hours ?? 0,
    totalValues: bookingVenue?.total_revenue ?? 0
  } as PieLayoutSummaryData

  const tableData = {
    headers: ['VENUES', 'HOURS', 'VALUES'],
    data: bookingVenue?.details?.map(d => {
      const venueName = d.venue_name
      return [venueName, d.total_hours, currencyFormat(d.total_revenue)]
    })
  } as PieLayoutTableData

  const pieChartData = {
    labels: details.map(d => d.venue_name ?? ''),
    datasets: [
      {
        label: 'Total Hours',
        data: details.map(d => d.total_hours),
        borderColor: pieColors,
        backgroundColor: pieColors,
        borderWidth: 1
      }
    ]
  } as PieChartData

  return (
    <>
      {
        bookingVenue && <BookingInsightPieLayoutResult
          overrideHeader='Venues'
          pieChartData={pieChartData}
          tableData={tableData}
          summaryData={summaryData} />

      }
    </>
  );
};

export default BookingCourtResult
;